import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagHK = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M27.581 18.913c-.568 2.363-1.578 1.912-2.073 3.973a5.435 5.435 0 0 1 2.54-10.569c-.99 4.122.041 4.482-.467 6.596ZM20.009 20.663c2.072 1.271 1.33 2.092 3.138 3.2a5.435 5.435 0 0 1-9.266-5.682c3.613 2.216 4.274 1.346 6.128 2.482ZM19.334 28.407c1.849-1.578 2.4-.62 4.012-1.996a5.435 5.435 0 1 1-8.267 7.057c3.224-2.752 2.601-3.65 4.255-5.06ZM26.49 31.441c-.93-2.246.152-2.475-.659-4.433a5.435 5.435 0 0 1 4.157 10.043c-1.621-3.916-2.667-3.601-3.498-5.61ZM31.587 25.574c-2.423.19-2.307-.91-4.42-.744a5.436 5.436 0 0 1 10.837-.85c-4.227.332-4.25 1.424-6.417 1.594Z"
}));
FlagHK.displayName = 'FlagHK';
export default withFlagWrapper(FlagHK);
//# sourceMappingURL=index.js.map